__turbopack_context__.v({
  "count": "MakeLabel-module__UpcIDa__count",
  "logo": "MakeLabel-module__UpcIDa__logo",
  "makeLabel": "MakeLabel-module__UpcIDa__makeLabel",
  "name": "MakeLabel-module__UpcIDa__name",
});
